import React, { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";
import AdminLayout from "../../components/app/AdminLayout";
import { Card, Loader } from "./Dashboard";
import {
  PieChart, Pie, Cell, ResponsiveContainer, Tooltip, BarChart, Bar, XAxis, YAxis,
} from "recharts";

export default function Reports() {
  const [stats, setStats] = useState(null);
  useEffect(() => { adminApi.get("/admin/stats").then(({ data }) => setStats(data)); }, []);

  if (!stats) return <AdminLayout title="Reports"><Loader /></AdminLayout>;

  const PALETTE = ["#D91616", "#8B5CF6", "#F59E0B", "#84CC16", "#3B82F6", "#EC4899"];

  const audienceRate = stats.audition_invites === 0 ? 0 :
    Math.round((stats.accepted_actors / stats.audition_invites) * 100);
  const acceptRate = stats.total_applications === 0 ? 0 :
    Math.round((stats.contracts_signed / stats.total_applications) * 100);

  return (
    <AdminLayout title="Reports" subtitle="Analytics and insights">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
        <Kpi label="Total Applications" value={stats.total_applications} sub="all-time" />
        <Kpi label="Audition Attendance" value={`${audienceRate}%`} sub="invite → accept" />
        <Kpi label="Acceptance Rate" value={`${acceptRate}%`} sub="apps → contracted" />
        <Kpi label="Talent Pool Size" value={stats.by_status.find((s) => s.key === "talent_pool")?.count || 0} sub="retained for future" />
      </div>

      <div className="grid lg:grid-cols-2 gap-3">
        <Card title="Applications by Gender">
          <div className="h-72">
            <ResponsiveContainer>
              <PieChart>
                <Pie data={stats.gender_breakdown} dataKey="count" nameKey="gender" innerRadius={60} outerRadius={100} paddingAngle={2}>
                  {stats.gender_breakdown.map((_, i) => <Cell key={i} fill={PALETTE[i%PALETTE.length]} />)}
                </Pie>
                <Tooltip contentStyle={{ background: "#0A0A0A", border: "1px solid #262626", fontSize: 12 }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="space-y-1.5 mt-2">
            {stats.gender_breakdown.map((g, i) => (
              <div key={g.gender} className="flex items-center justify-between text-xs">
                <span className="flex items-center gap-2 text-[#A19D94]"><span className="w-2 h-2 rounded-full" style={{ background: PALETTE[i%PALETTE.length] }} />{g.gender}</span>
                <span className="font-mono">{g.count}</span>
              </div>
            ))}
          </div>
        </Card>

        <Card title="Applications by Experience">
          <div className="h-72">
            <ResponsiveContainer>
              <PieChart>
                <Pie data={stats.experience_breakdown} dataKey="count" nameKey="level" innerRadius={60} outerRadius={100} paddingAngle={2}>
                  {stats.experience_breakdown.map((_, i) => <Cell key={i} fill={PALETTE[i%PALETTE.length]} />)}
                </Pie>
                <Tooltip contentStyle={{ background: "#0A0A0A", border: "1px solid #262626", fontSize: 12 }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="space-y-1.5 mt-2">
            {stats.experience_breakdown.map((e, i) => (
              <div key={e.level || i} className="flex items-center justify-between text-xs">
                <span className="flex items-center gap-2 text-[#A19D94]"><span className="w-2 h-2 rounded-full" style={{ background: PALETTE[i%PALETTE.length] }} />{(e.level || "Unknown").slice(0,30)}</span>
                <span className="font-mono">{e.count}</span>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </AdminLayout>
  );
}

const Kpi = ({ label, value, sub }) => (
  <div className="border border-[#1a1a1a] bg-[#0A0A0A] p-4">
    <div className="label-mini">{label}</div>
    <div className="font-display text-3xl font-bold mt-2">{value}</div>
    <div className="text-[10px] text-[#6B6862] mt-1 font-mono uppercase tracking-wider">{sub}</div>
  </div>
);
